import * as types from "./types";

export const setPackages = (payload) => ({
  type: types.SET_PACKAGES,
  payload: payload,
});
export const setSelectedPackage = (payload) => ({
  type: types.SET_SELECTED_PACKAGE,
  payload: payload,
});
export const setConsultationOrder = (payload) => ({
  type: types.SET_CONSULTATION_ORDER,
  payload: payload,
});
export const setConsultationRequest = (payload) => ({
  type: types.SET_CONSULTATION_REQUEST,
  payload: payload,
});
export const setConsultationRequests = (payload) => ({
  type: types.SET_CONSULTATION_REQUESTS,
  payload: payload,
});
